import PropTypes from 'prop-types';
import React from 'react';
import PortableText from '@utility/PortableText';
import ScrollInView from '@utility/ScrollInView/index';
import cn from 'classnames';
import * as styles from './styles.module.scss';
import ContentWithSuperscript from '../CollectionTitle';

const ContentColumns = ({ data: { columnLeft, columnRight } }) => (
  <ScrollInView>
    <div className="wrapper">
      <div className="row">
        <div className="col-12 sm:col-10 lg:col-4">
          {columnLeft && (
            <h2
              className={cn(
                styles.heading,
                'lg-down:mb-10 type-sans-530 md:type-sans-630',
              )}
            >
              <ContentWithSuperscript content={columnLeft} />
            </h2>
          )}
        </div>
        <div className="col-10 offset-2 lg:col-7 lg:offset-1">
          {columnRight.richText && (
            <div className="richtext-content type-sans-430">
              <PortableText blocks={columnRight.richText} />
            </div>
          )}
        </div>
      </div>
    </div>
  </ScrollInView>
);

ContentColumns.propTypes = {
  data: PropTypes.shape({
    columnLeft: PropTypes.string,
    columnRight: PropTypes.shape({
      richText: PropTypes.array,
    }).isRequired,
  }),
};

ContentColumns.defaultProps = {
  data: {
    columnLeft: '',
    columnRight: {},
  },
};

export default ContentColumns;
